import React, { useState } from 'react';
import { DENTAL_RISK_SQL_SCRIPT } from '../../lib/riskConstants';

/**
 * SQL Migration Modal with Copy-to-Clipboard
 */
export default function RiskSqlMigrationModal({ isOpen = false, onClose }) {
  const [copySuccess, setCopySuccess] = useState(false);

  if (!isOpen) return null;

  const handleCopySql = () => {
    navigator.clipboard.writeText(DENTAL_RISK_SQL_SCRIPT);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2500);
  };

  return (
    <div
      className="risk-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="SQL Migration Script"
    >
      <div
        className="risk-modal-box"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '720px' }}
      >
        <div
          style={{
            padding: '18px 24px',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#f8fafc'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>💾</span>
            <div>
              <h3 style={{ margin: 0, fontSize: '1.15em', fontWeight: '800', color: '#0f172a' }}>
                SQL Migration สำหรับตาราง dental_risk_reports
              </h3>
              <div style={{ fontSize: '0.82em', color: '#64748b' }}>
                คัดลอกคำสั่ง SQL ด้านล่างนี้ไปรันใน Supabase SQL Editor เพื่อสร้างหรืออัปเดตตาราง
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '22px',
              color: '#94a3b8',
              cursor: 'pointer'
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          <div style={{ position: 'relative' }}>
            <button
              type="button"
              onClick={handleCopySql}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                padding: '8px 14px',
                borderRadius: '8px',
                backgroundColor: copySuccess ? '#10b981' : '#0284c7',
                color: '#ffffff',
                border: 'none',
                fontWeight: '700',
                fontSize: '0.82em',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                transition: 'all 0.15s ease'
              }}
            >
              {copySuccess ? '✓ คัดลอกสำเร็จ!' : '📋 คัดลอก SQL'}
            </button>
            <pre
              className="risk-scrollbar"
              style={{
                backgroundColor: '#0f172a',
                color: '#f8fafc',
                padding: '16px',
                borderRadius: '12px',
                fontSize: '0.82em',
                lineHeight: '1.5',
                overflowX: 'auto',
                margin: 0,
                maxHeight: '400px'
              }}
            >
              {DENTAL_RISK_SQL_SCRIPT}
            </pre>
          </div>
        </div>

        <div
          style={{
            padding: '14px 20px',
            borderTop: '1px solid #e2e8f0',
            backgroundColor: '#f8fafc',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px'
          }}
        >
          <button
            type="button"
            onClick={handleCopySql}
            style={{
              padding: '8px 18px',
              borderRadius: '8px',
              backgroundColor: '#0284c7',
              color: '#ffffff',
              border: 'none',
              fontWeight: '700',
              fontSize: '0.88em',
              cursor: 'pointer'
            }}
          >
            {copySuccess ? '✓ คัดลอกสำเร็จ' : 'คัดลอก SQL'}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '8px 18px',
              borderRadius: '8px',
              backgroundColor: '#ffffff',
              color: '#475569',
              border: '1px solid #cbd5e1',
              fontWeight: '600',
              fontSize: '0.88em',
              cursor: 'pointer'
            }}
          >
            ปิด
          </button>
        </div>
      </div>
    </div>
  );
}
